import React from "react";

import { Tooltip } from "@material-ui/core";
import NewIcon from "@material-ui/icons/RadioButtonUnchecked";
import AvailableIcon from "@material-ui/icons/CheckCircleOutline";
import UnavailableIcon from "@material-ui/icons/HighlightOff";
// import TemporarilyUnavailableIcon from '@material-ui/icons/ErrorOutline';
import { green, red } from "@material-ui/core/colors";

import { ServiceStatus } from "../../../utils/constants";

export const ServiceStatusIcon = (props) => {
  const { classes } = props;

  if (!props.record?.status) return null;
  const icon = () => {
    switch (props.record.status) {
      case ServiceStatus.AVAILABLE:
        return (
          <Tooltip title="Available" placement="left" arrow>
            <AvailableIcon className={classes} style={{ color: green[700] }} />
          </Tooltip>
        );
      case ServiceStatus.UN_AVAILABLE:
        return (
          <Tooltip title="Unavailable" placement="left" arrow>
            <UnavailableIcon className={classes} style={{ color: red[700] }} />
          </Tooltip>
        );
      default:
        return <NewIcon className={classes} />;
    }
  };

  return icon();
};
